import { useTranslator } from '@jutro/locale';
import {
    ViewModelForm
} from '@xengage/gw-portals-viewmodel-react';
import _ from 'lodash';
import React, {
    
} from 'react';
import messages from './EFTInfoTable.messages';
import metadata from './EFTInfoTable.metadata.json5';
import styles from './EFTInfoTable.module.scss';

function EFTInfoTable(props) {
    const { group } = props;
    // eslint-disable-next-line no-secrets/no-secrets
    const registrationfailed = _.get(group, 'agentEFT_TWIA.isRegistrationFailed.value');
    // eslint-disable-next-line no-secrets/no-secrets
    const registrationFailedMessage = _.get(group, 'agentEFT_TWIA.registrationFailedMessage.value');
    const isEFTSuspended = _.get(group, 'eftstatus_TWIA.value.code') === 'suspended';
    const translator = useTranslator();

    
    // DE16898
    function suspendedMessage() {
        return (
            <div>
                <span style={{ display: 'flex' }}>
                    <text style={{ paddingLeft: '6px' }}>{translator(messages.suspendedMessage)}</text>
                </span>
            </div>
        );
    };

    const overrideProps = {
        '@field': {
            labelPosition: 'left',
            phoneWide: {
                labelPosition: 'top',
            },
        },
        eftPayTitle: {
            content: translator(messages.eftPayTitle)  
        },
        eftPayMessage: {
            content: translator(messages.eftPayMessage)
        },
        suspendedMessageContainer: { // DE16898
            visible: isEFTSuspended,
            content: suspendedMessage()
        },
        failedMessage: {
            visible: registrationfailed === true,
            message: translator(messages.enrollmentFailed, {errorMessage: 
                registrationFailedMessage})
        },
        eftAccount: {
            // eslint-disable-next-line no-secrets/no-secrets
            value: `****${_.get(group, 'agentEFT_TWIA.accountNumberLast4.value')}`
        },
        accountGrid: {
            // eslint-disable-next-line no-secrets/no-secrets
            visible: !_.isUndefined(_.get(group, 'agentEFT_TWIA.accountNumberLast4.value'))
        },
        accountGridEnd: {
            // eslint-disable-next-line no-secrets/no-secrets
            visible: !_.isUndefined(_.get(group, 'agentEFT_TWIA.accountNumberLast4.value'))
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {   
            // addressSummaryComponent: AddressSummary              
        },
        resolveCallbackMap: {
            // editPrimaryContactDetails
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={group}
            overrideProps={overrideProps}
            // onValueChange={handleSearchValueChange}
            classNameMap={resolvers.resolveClassNameMap}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
        />
    );
}

EFTInfoTable.propTypes = {
    
};

EFTInfoTable.defaultProps = {

};

export default EFTInfoTable;
